import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class NotAFolderGitError extends GitError {
  constructor(path: string, append = true) {
    super(append ? `Element at "${path}" is not a folder` : path);
  }

  readonly gitErrorCode = GitErrorStatusCode.NotAFolder;
}
